"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreManager = void 0;
const lodash_1 = require("lodash");
const fetch_error_1 = require("../errors/fetch.error");
const http_1 = require("../utils/http");
const memoize_1 = require("../utils/memoize");
const cache_manager_1 = require("./cache.manager");
class StoreManager {
    /**
     * @param tenantConfig - Tenant Config
     * @param module - CMS Module (app-features, email-templates, etc)
     * @param category -Module category: used for accessing sub folders
     */
    constructor(tenantConfig, module, category) {
        this.tenantConfig = tenantConfig;
        this.module = module;
        this.category = category;
        this.cacheManager = new cache_manager_1.CacheManager(tenantConfig);
    }
    get key() {
        if (this.category) {
            return [this.module, this.category].join('.');
        }
        else {
            return this.module;
        }
    }
    get logStamp() {
        return `CMS Content ${this.key} Runtime`;
    }
    /**
     * Generates Remote Resource URL
     * @returns {String} Remote Resource URL
     */
    generateResourceUrl() {
        const segments = [this.tenantConfig.remoteBaseUrl];
        if (this.tenantConfig.environment !== 'production') {
            segments.push(this.tenantConfig.environment);
        }
        segments.push(this.tenantConfig.countryCode);
        segments.push(this.module);
        if (this.category) {
            segments.push(this.category);
        }
        const fileName = segments.join('/');
        const extension = 'json';
        return [fileName, extension].join('.');
    }
    /**
     * Fetch directly from resource
     */
    async fetch(key) {
        const url = this.generateResourceUrl();
        if (this.tenantConfig.debug) {
            console.info('GET', url);
            console.info('KEY', key);
        }
        try {
            const response = await http_1.cmsAxiosInstance.get(url);
            return response.data;
        }
        catch (error) {
            const fetchError = new fetch_error_1.CMSFetchError({
                tenantConfig: this.tenantConfig,
                module: this.module,
                error: error,
                moduleCategory: this.category
            });
            if (this.tenantConfig.debug)
                console.error(fetchError);
            throw fetchError;
        }
    }
    /**
     * Get resource memoized resource data
     */
    async get() {
        const fetch = (key) => this.fetch(key);
        const cache = this.cacheManager.getStorage(this.key);
        const exec = (0, memoize_1.default)(fetch, { cache: cache });
        if (this.tenantConfig.debug)
            console.time(this.logStamp);
        const response = await exec(this.key);
        if (this.tenantConfig.debug)
            console.timeEnd(this.logStamp);
        return (0, lodash_1.cloneDeep)(response);
    }
}
exports.StoreManager = StoreManager;
//# sourceMappingURL=store.manager.js.map